module.exports = __webpack_public_path__ + "img/vcu2.78c4514c.png";